<template>
    <div class="examAllClass" style="height:100%;width:100%;">
        <el-dialog
            title="系统统计"
            :visible.sync="statisticalSwitch"
            width="55%"
            top='7vh'
            :show-close="false"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            class="dialogStatisticals"
            :before-close="handleClose">
            <el-table
                :data="flages"
                stripe
                border
                size="mini"
                class="noWriteTable"
                :max-height="tableHeight"
                style="width: 100%;border-color:#111113;">
                <el-table-column prop="index" align="center" label="题目序列" width="100"></el-table-column>
                <el-table-column prop="msg" align="left" label="上传状态">
                    <template slot-scope="scope"><span style="font-weight: bold;" v-html="scope.row.msg">{{scope.row.msg}}</span></template>
                </el-table-column>
                <el-table-column prop="msg" align="center" label="操作">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isSurrenderShow">
                            <span v-if="scope.row.answerType">已放弃上传</span>
                            <el-button v-else size="mini" @click="giveUpHomework(scope.row,scope.$index)" :disabled="scope.row.msg=='已答题'" type="warning" class="giveUpTest">放弃上传</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <p class="titleTap">系统监测到当前有<b style="color:red">{{isNotRespond.length}}</b>道题未完成，请问是否确认提交，提交视为结束填报不可再次填报。</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="goSubmit()">提交填报</el-button>
                <el-button type="primary" @click="statisticalSwitch = false">继续填报</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import utils from '../../lib/util'
export default {
    name:'examAllOk',
    data() {
        return {
            statisticalSwitch:false,
            jsonData:[],
            flages:[],
            isNotRespond:[],
            tableHeight:'700'
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.conHeightFun()
        })
        window.addEventListener('resize', () => this.conHeightFun(), false)
    },
    methods:{
        conHeightFun(){
            var scrollBoxH = document.getElementsByClassName('examAllClass')[0]
            var hg = window.getComputedStyle(scrollBoxH).height
            this.tableHeight=Number(hg.substring(0,hg.length-2)-130);
        },
        open(jsonData,jsonDataJudge,flage){
            let that = this
            this.flages = []
            this.isNotRespond = flage
            this.jsonData = jsonData
            this.statisticalSwitch = true
            
            for (let n = 0; n < this.jsonData.length; n++) {
                let isSshow = true
                this.flages.push({
                    'index':`第${utils.intToChinese(n+1)}题`,
                    'msg': (function() {
                        if(jsonDataJudge[n]!='120'){
                            isSshow = flage.includes(n)? true:false 
                           return flage.includes(n)?'未答题':'已答题'
                        } else {
                            let docs = that.jsonData[n]['designUrl'],arr = []
                            arr = docs? docs.split(',').filter((son)=>son):[]
                            isSshow = arr.length > 0?false:true
                            let str = '';
                            str = `已上传文件数量 ${arr.length} 个：`
                            if(docs) {
                                arr.forEach(son => {
                                    if(son)
                                    str += '<br/>'+son.split('/')[son.split('/').length-1]
                                });
                            }
                            return str
                        }
                    })(),
                    'answerType':this.jsonData[n].answerType,
                    'location':n,
                    "paperQuestionId":this.jsonData[n].paperQuestionId,
                    'isSurrenderShow':isSshow
                })
            }
        },
        handleClose(done){
            this.jsonData = []
            this.flages = []
            done();
        },
        giveUpHomework(row,i){
            this.$confirm('放弃将视为主动放弃，放弃后在答题之后完成答题，则系统会记录答题结果并自动取消放弃答题状态。','提示',{
                confirmBottonText:'放弃作答',
                cancelBottonText:'取 消',
            })
            .then(()=>{
                this.flages[i].answerType = 1
                this.$emit('editAnswerType',row)
            })
            .catch((action)=>{})
        },
        goSubmit(){
            this.$emit('mandatoryAjax')
        },
        offDialog(){
            this.statisticalSwitch = false
        }
    }
}
</script>
<style scoped>
    .examAllClass{
        height: 100%;
        width: 100%;
    }
    .titleTap{
        font-size: 18px;
        font-weight: bold;
        box-sizing: border-box;
        padding: 30px 15px 0 15px;
        text-align: center;
    }
</style>
<style>
    .dialogStatisticals .el-dialog{
        width: 850px !important;
    }
    .dialogStatisticals .el-dialog__body {
        padding: 10px 15px !important;
    }
    .noWriteTable td,
    .noWriteTable th{    
        border-color: #111113 !important;
    }
    .noWriteTable::after,
    .noWriteTable::before{
        background-color: #111113 !important;
    }
    .dialogStatisticals .el-table_1_column_3{
        padding: 2px 0 !important;
    }
    .giveUpTest{
        padding: 6px 15px !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/exam2/examAllOk.vue